import isEmpty from 'lodash/isEmpty';
import type { Group } from '../types.ts';

export const isGroupReallyEmpty = (group: Group): boolean =>
  isEmpty(group.demographic_age?.segments) &&
  isEmpty(group.demographic_gender?.segments) &&
  isEmpty(group.location?.segments) &&
  isEmpty(group.direct?.segments) &&
  isEmpty(group.predefined?.segments) &&
  isEmpty(group.lookalike?.segments);
